import { MB_CONFIG } from '../config'

export default {

    /*
    *    GET /api/v1/document/years
    */
    YEARS: () => axios.get(MB_CONFIG.API_URL + '/document/years'),

    /*
    *    GET /api/v1/document/year/{year}
    */
    DOCUMENTS: (year) => axios.get(MB_CONFIG.API_URL + '/document/year/' + year),

    /*
    *    GET /api/v1/document/{documentID}
    */
    DOCUMENT: (documentID) => axios.get(MB_CONFIG.API_URL + '/document/' + documentID),

    DOWNLOAD: id => axios.get(MB_CONFIG.API_URL + '/document/' + id + '/pdf', { responseType: 'blob' }),

    SAVE: document => document.id ? axios.put(MB_CONFIG.API_URL + '/document/' + document.id, document) : axios.post(MB_CONFIG.API_URL + '/document', document),

    /*
    *    DELETE /api/v1/document/{documentID}
    */
    deleteDocument: (documentID) => axios.delete(MB_CONFIG.API_URL + '/document/' + documentID),

    /*
    *    PUT /api/v1/patients/{patientID}
    */
    putPatient: (doc) => axios.put(MB_CONFIG.API_URL + '/patients/' + doc.id, doc),

}
